// src/components/Dashboard.js
import React from 'react';
import { useAuthContext } from '../context/AuthContext';
import CoachDashboard from './CoachDashboard';
import ClientDashboard from './ClientDashboard';
import AdminDashboard from './AdminDashboard';

const Dashboard = () => {
  const { user } = useAuthContext();

  // Si aún está cargando la info o no hay usuario, muestra un loader o nada.
  if (!user) {
    return (
      <div className="w-full h-full container mx-auto p-4 md:p-8 animate-fade-up">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {[1, 2, 3].map((item) => (
            <div key={item} className="glass-panel rounded-xl p-6">
              <div className="skeleton h-6 w-2/3 rounded mb-3" />
              <div className="skeleton h-4 w-full rounded mb-2" />
              <div className="skeleton h-4 w-4/5 rounded" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  // 3. Renderizado condicional basado en el rol
  return (
    <div className="w-full h-full container mx-auto p-4 md:p-8 animate-fade-up">
      {user.role === 'admin' ? <AdminDashboard /> : user.role === 'coach' ? <CoachDashboard /> : <ClientDashboard />}
    </div>
  );
};

export default Dashboard;